import { spacing } from './spacing';
import { color } from './colors';
import { pxToRem } from '../utils/base';
// font
const font = {
    size: pxToRem(16),
    weight: {
        regular: 400,
        bold: 700,
    },
    family: {
        sansSerif: `Lato,'Lucida Grande',Tahoma,'Helvetica Neue',Helvetica,-apple-system,BlinkMacSystemFont,'Segoe UI','PingFang SC','Hiragino Sans GB','Microsoft YaHei',Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'`,
        serif: `Volkhov,Georgia,Times,Serif`,
        headline: `Lato,'Helvetica Neue',Helvetica,-apple-system,BlinkMacSystemFont,'Segoe UI','PingFang SC','Hiragino Sans GB','Microsoft YaHei',Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'`,
        code: `'Roboto Mono',SFMono-Regular,Consolas,'Liberation Mono',Menlo,Courier,monospace`,
    },
    lineHeight: {
        default: 1.375, // 22px/16px (chosen as average of previous non ratio values)
    },
};
// headlines
const h1 = {
    fontSize: pxToRem(46),
    margin: '46px 0 13px',
    padding: '0',
};
const h2 = {
    fontSize: pxToRem(36),
    margin: '42px 0 16px',
    padding: '0',
};
const h3 = {
    fontSize: pxToRem(30),
    margin: '40px 0 17px',
    padding: '0',
};
const h4 = {
    fontSize: pxToRem(24),
    margin: '38px 0 20px',
    padding: '0',
};
const h5 = {
    fontSize: pxToRem(18),
    margin: '36px 0 22px',
    padding: '0',
};
const h6 = {
    fontSize: pxToRem(13),
    margin: '34px 0 24px',
    padding: '0',
};
// textStyles
const jumbo = {
    fontSize: pxToRem(24),
};
const big = {
    fontSize: pxToRem(18),
};
const normal = {
    fontSize: pxToRem(16),
};
const small = {
    fontSize: pxToRem(14),
};
const micro = {
    fontSize: pxToRem(13),
};
const notification = {
    fontSize: pxToRem(14),
};
// attribution
const quote = {
    fontSize: pxToRem(30),
};
const author = {
    fontSize: pxToRem(18),
};
// code
const code = {
    fontSize: pxToRem(13),
    contrastBackgroundColor: color.N10,
    contrastColor: color.N5,
    padding: spacing.lg,
};
// Google Fonts URL docs: https://developers.google.com/fonts/docs/css2
export function getFontImportsURL() {
    // TODO: It'd be nice if this were configurable.
    const italicFonts = new Set(['Lato']);
    const constructFontFamily = (fontFamilyName, weights) => {
        // remove all quote marks and replace spaces with pluses
        const formattedName = fontFamilyName.replace(/['"]+/g, '').replace(/\s+/g, '+');
        const loadItalicFont = italicFonts.has(formattedName);
        const resolvedWeights = [];
        // Google's API is very particular. If we're supposed to include the
        // italicized version we need to include things in a very specific
        // shape and order, which is what this code does.
        if (loadItalicFont) {
            for (const w of weights) {
                resolvedWeights.push([0, w].join(','));
            }
            for (const w of weights) {
                resolvedWeights.push([1, w].join(','));
            }
        }
        else {
            resolvedWeights.push(...weights);
        }
        const ital = loadItalicFont ? 'ital,' : '';
        return `family=${formattedName}:${ital}wght@${resolvedWeights.join(';')}`;
    };
    const weights = [font.weight.regular, font.weight.bold];
    const sansSerifFont = font.family.sansSerif.split(',')[0];
    const serifFont = font.family.serif.split(',')[0];
    const codeFont = font.family.code.split(',')[0];
    const googleFonts = [sansSerifFont, serifFont, codeFont]
        .map((fontName) => constructFontFamily(fontName, weights))
        .join('&');
    return `https://fonts.googleapis.com/css2?${googleFonts}&display=swap`;
}
export const typography = {
    font,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    textStyles: {
        jumbo,
        big,
        normal,
        small,
        micro,
        notification,
        quote,
        author,
        code,
    },
};
//# sourceMappingURL=typography.js.map